import { Card } from 'antd'
import styled from 'styled-components'

const CardComponent = styled(Card)`
  .ant-card-body {
    padding: 12px 8px;
  }

  width: 100%;
`

export default CardComponent
